<template>
  <div v-if="loading" class="preview-multi-select">
    <b>{{ filtro.name }}:</b> <span>{{ $i18n('interface.novo_filtro.selecione') }}</span>
  </div>
  <MultiSelect
    v-else
    :label="filtro.name"
    :campos="produtos"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    :buscaRemota="true"
    :buscando="buscando"
    classeDropdown="dropdown-produto"
    @atualizar="onAtualizar"
    @buscar="buscarProdutos"
  />
</template>
<script>
import { ref, toRef, onMounted, getCurrentInstance } from 'vue';
import MultiSelect from '../../components/MultiSelect.vue';
import { useFiltroMultiSelect } from '../../composables/useFiltroMultiSelect';

const ENDPOINT_POR_CODIGO = '/produto_estoques/busca_codigo_mesmo_zerado';
const ENDPOINT_POR_DESCRICAO = '/produto_estoques/busca_descricao';

export default {
  components: { MultiSelect },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();

    const selecionadosDoServidor = () => (props.filtro.selecionados || []).map(item => ({
      id: item.id,
      name: item.name,
    }));

    const produtos = ref(selecionadosDoServidor());
    const loading = ref(true);
    const buscando = ref(false);
    const termoAtual = ref('');

    const { onAtualizar } = useFiltroMultiSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
    });

    function unicosPorId(itens) {
      const porId = new Map();
      itens.forEach(item => {
        if (!porId.has(String(item.id))) porId.set(String(item.id), item);
      });
      return Array.from(porId.values());
    }

    function buscarProdutos(term = '') {
      buscando.value = true;
      termoAtual.value = term;

      const porCodigo = proxy.$api.get(ENDPOINT_POR_CODIGO, { params: { term } });
      const porDescricao = proxy.$api.get(ENDPOINT_POR_DESCRICAO, { params: { term, buscar_zerados: 1 } });

      return Promise.all([porCodigo, porDescricao]).then(([respostaCodigo, respostaDescricao]) => {
        if (termoAtual.value !== term) return;
        const encontrados = [...respostaCodigo.data, ...respostaDescricao.data].map(produto => ({
          id: produto.id,
          name: produto.label,
        }));
        produtos.value = unicosPorId([...selecionadosDoServidor(), ...encontrados]);
      }).catch(error => {
        if (termoAtual.value !== term) return;
        console.error('Erro ao buscar produtos:', error);
      }).finally(() => {
        if (termoAtual.value === term) {
          buscando.value = false;
          loading.value = false;
        }
      });
    }

    onMounted(() => {
      buscarProdutos();
    });

    return { produtos, loading, buscando, onAtualizar, buscarProdutos };
  },
}
</script>
